<template>
  <!-- 回单管理 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div
      class="glo_btnList"
      ref="btnList"
    >
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('admin:return_order:returnSure')"
          class="glo_btnItems"
          @click="SHConfirm"
        >收回确认</el-button>
        <el-button
          v-if="hasPermiss('admin:return_order:cancelReturnSure')"
          class="glo_btnItems"
          @click="cancelReturnSure"
        >取消收回</el-button>
        <el-button
          v-if="hasPermiss('admin:return_order:returnCustomer')"
          class="glo_btnItems"
          @click="returnCustomer"
        >返回客户</el-button>

        <el-dropdown
          class="topDropDown"
          @command="topCommandBtns"
        >
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          ></multitime>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="运单号:"
        >
          <el-input
            clearable
            placeholder="请输入"
            v-model="queryData.waybillNumber"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="当前网点:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.currentDeptId"
            placeholder="请选择"
            @focus="getDeptList"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="item in depList"
              :key="item.deptId"
              :label="item.departmentName"
              :value="item.deptId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="运单状态:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.waybillStatus"
            placeholder="请输入"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="(item, index) in waybillStatusList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="收回状态:"
        >
          <el-select
            clearable
            v-model="queryData.retractionStatus"
            placeholder="请选择"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="item in retraction_status_list"
              :key="item.statusVal"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="回单状态:"
        >
          <el-select
            clearable
            v-model="queryData.returnStatus"
            placeholder="请选择"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="item in return_status_list"
              :key="item.statusVal"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="返客户状态:"
        >
          <el-select
            clearable
            v-model="queryData.rnCustomerStatus"
            placeholder="请选择"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="item in rn_customer_status_list"
              :key="item.statusVal"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="客户名称:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.customerName"
            placeholder="请输入客户名称"
            remote
            :remote-method="getCustomerList"
            @change="changeCustomerNumber"
            @focus="getCustomerList()"
          >
            <el-option
              v-for="(item, index) in CustomerLists"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <!-- <el-table-column
            v-if="item.field == 'waybillNumber' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                class="linkTabel"
                @click.stop="$TOOLS.goYdDetails(scope.row)"
              >
                {{ scope.row.waybillNumber }}
              </div>
            </template>
          </el-table-column>-->
          <el-table-column
            v-if="item.field == 'hdimgs' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                class="linkTabel"
                v-if="hasPermiss('admin:return_order:getRnorderRnFileList')"
                @click.stop="lookImgs(scope.row)"
              >查看图片</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="320px"
        >
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                v-if="hasPermiss('admin:return_order:allocationSend')"
                class="rbtns"
                @click.stop="WaybillEdit(scope.row)"
              >调拨发出</el-button>
              <el-button
                v-if="hasPermiss('admin:return_order:allocationReceive')"
                class="rbtns"
                @click.stop="allocationReceive(scope.row)"
              >调拨接收</el-button>
              <el-button
                v-if="hasPermiss('admin:return_order:uploadRnorderFile')"
                class="rbtns"
                @click.stop="upLoadImgsBtns(scope.row)"
              >上传回单图</el-button>
              <el-button
                v-if="hasPermiss('admin:return_order:getAallocationRecordList')"
                class="rbtns"
                @click.stop="diaoBoLog(scope.row)"
              >调拨记录</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 客户跟踪 -->
    <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>

    <!-- 收回确认 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItems"
            prop="returnDeptId"
            label="收回部门:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.returnDeptId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in depList"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="returnUserId"
            label="收回人:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.returnUserId"
              placeholder="请选择"
              remote
              :remote-method="getAccountList"
              @focus="getAccountList()"
            >
              <el-option
                v-for="(item, index) in AccountList"
                :key="index"
                :label="item.name"
                :value="item.userId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="图片:"
            style="width: 100%"
          >
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="6"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 返回客户 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogFormRef2')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog2"
          ref="dialogFormRef2"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm2"
        >
          <el-form-item
            class="dislogFormTextarea"
            prop="rnCustomerRemarks"
            label="备注:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.rnCustomerRemarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 调拨发出 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3('dialogFormRef3')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog3"
          ref="dialogFormRef3"
          :model="dialogForm3"
          label-width="100px"
          :rules="rulesForm3"
        >
          <el-form-item
            class="dialogFormItems"
            prop="operationDeptId"
            label="发出部门:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm3.operationDeptId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in depList"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="operationObjectId"
            label="发出人:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm3.operationObjectId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in employeeList"
                :key="item.deptId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="endDeptId"
            label="接收部门:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm3.endDeptId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in depList"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="endObjectId"
            label="接收人:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm3.endObjectId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in employeeList"
                :key="item.deptId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dislogFormTextarea"
            prop="remarks"
            label="发出备注:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm3.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 调拨接收 -->
    <myDialog
      :diaWidth="diaWidth4"
      :dialogTitle="dialogTitle4"
      :isShowDialog="isShowDialog4"
      @handleCloseDia="handleCloseDia4"
      @diaCancelBtn="handleCloseDia4"
      @diaConfirmBtn="diaConfirmBtn4('dialogFormRef4')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog4"
          ref="dialogFormRef4"
          :model="dialogForm4"
          label-width="100px"
          :rules="rulesForm4"
        >
          <el-form-item
            class="dialogFormItems"
            prop="operationDeptId"
            label="接收部门:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm4.operationDeptId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in depList"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="operationObjectId"
            label="接收人:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm4.operationObjectId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in employeeList"
                :key="item.deptId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dislogFormTextarea"
            prop="remarks"
            label="接收备注:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm4.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 调拨记录 -->
    <myDialog
      :diaWidth="diaWidth5"
      :dialogTitle="dialogTitle5"
      :isShowDialog="isShowDialog5"
      :showConfirm="false"
      @handleCloseDia="isShowDialog5 = false"
      @diaCancelBtn="isShowDialog5 = false"
    >
      <!-- 表格 -->
      <div class="glo_Table">
        <el-table
          header-align="center"
          ref="mytable5"
          :data="tableData5"
          border
          stripe
          :highlight-current-row="true"
        >
          <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
          ></el-table-column>

          <template v-for="(item, index) in myTableHeard5">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            ></el-table-column>
          </template>
        </el-table>
      </div>
    </myDialog>

    <!-- 收回确认 -->
    <myDialog
      :diaWidth="diaWidth6"
      :dialogTitle="dialogTitle6"
      :isShowDialog="isShowDialog6"
      @handleCloseDia="handleCloseDia6"
      @diaCancelBtn="handleCloseDia6"
      @diaConfirmBtn="diaConfirmBtn6('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog6"
          ref="dialogFormRef"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item
            label="回单图片:"
            style="width: 100%"
          >
            <uploadimgs
              @input="changeFileList6"
              :fileNameLists="fileNameLists6"
              :limit="6"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 大图预览 -->
    <el-dialog
      :title="titleH"
      :visible.sync="bigImgsShow"
      width="50%"
      center
      :close-on-click-modal="false"
    >
      <div
        class
        style="display: flex"
      >
        <div
          v-for="(item, index) in srcList"
          :key="index"
        >
          <el-image
            style="width: 180px; height: 180px; margin: 10px"
            :src="item"
            :preview-src-list="srcList"
          ></el-image>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="warning"
          size="mini"
          @click="bigImgsShow = false"
        >关闭</el-button>
      </span>
    </el-dialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form
          :model="queryData"
          class="glo_form hasMoreParam"
          label-position="left"
        >
          <!-- 时间组件 -->
          <el-form-item class="queryItemsTimes">
            <multitime
              :timeType="timeType"
              :timeTypes="timeTypes"
              :startTime="startTime_a"
              :endTime="endTime_a"
              @timestatus="timestatus"
              @queryBtn_ok="queryBtn_time"
            ></multitime>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="运单号:"
          >
            <el-input
              clearable
              placeholder="请输入"
              v-model="queryData.waybillNumber"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="当前网点:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.currentDeptId"
              placeholder="请选择"
              @focus="getDeptList"
              @change="queryBtn_ok"
            >
              <el-option
                v-for="item in depList"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="运单状态:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.waybillStatus"
              placeholder="请输入"
              @change="queryBtn_ok"
            >
              <el-option
                v-for="(item, index) in waybillStatusList"
                :key="index"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="收回状态:"
          >
            <el-select
              clearable
              v-model="queryData.retractionStatus"
              placeholder="请选择"
              @change="queryBtn_ok"
            >
              <el-option
                v-for="item in retraction_status_list"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="回单状态:"
          >
            <el-select
              clearable
              v-model="queryData.returnStatus"
              placeholder="请选择"
              @change="queryBtn_ok"
            >
              <el-option
                v-for="item in return_status_list"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="返客户状态:"
          >
            <el-select
              clearable
              v-model="queryData.rnCustomerStatus"
              placeholder="请选择"
              @change="queryBtn_ok"
            >
              <el-option
                v-for="item in rn_customer_status_list"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="客户名称:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.customerName"
              placeholder="请输入客户名称"
              remote
              :remote-method="getCustomerList"
              @change="changeCustomerNumber"
              @focus="getCustomerList()"
            >
              <el-option
                v-for="(item, index) in CustomerLists"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
  </div>
</template>
<script>
import sorttable from '@/components/sortTemplate.vue' //自定义排序表头
import paging from '@/components/pagings.vue' //分页组件
import multitime from '@/components/multiTime.vue'
import myDialog from '@/components/Dialog.vue'
import queryBtns from '@/components/queryBtns.vue'
import addCustomerTarck from '@/components/CustomerServiceTrackingNew.vue'
import uploadimgs from '@/components/upLoadImgs.vue'
import exportjs from '@/assets/js/Mixins/export.js' //导出的公共js
export default {
  inject: ['reload'],
  mixins: [exportjs],
  components: {
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    uploadimgs,
    queryBtns,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: '',
        fileName: '回单管理列表',
        apiName: '/common/v1/dict/status/getStatusValList', //导出的数据列表接口名
        EpType: 'bdd', //dd==等待下载完成,bdd==不等待完成
        apiType: 'GET', //导出当前列表的请求方式
        pageType: 'ReceiptManage', //页面类型(主要用来区分查询参参数的时间)
      },
      //=======================导出相关 结束 =======================
      srcList: [],
      showFilse: false,
      bigImgsShow: false,
      titleH: '预览图片',
      //  -----  查询  ------
      queryData: {
        currentDeptId: '',
        startReturnTime: '',
        endReturnTime: '',
        retractionStatus: '',
        returnStatus: '',
        rnCustomerStatus: '',
        waybillNumber: '',
        waybillStatus: '',
        customerName:'',
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: '0',
          label: '运单创建日期',
        },
        {
          value: '1',
          label: '收回时间',
        },
      ],
      timeType: '0', //  时间类型
      startTime_a: '',
      endTime_a: '',

      MoreConditions: '更多条件', //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: '75vh', //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: '客户单号',
          field: 'customerOrderNumber',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '运单号',
          field: 'waybillNumber',
          width: '160',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '开单网点',
          field: 'businessDeptName',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '终端网点',
          field: 'endDeptName',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '收回状态',
          field: 'retractionStatusShow',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '回单当前所在网点',
          field: 'currentDeptName',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: '已返客户',
          field: 'rnCustomerStatusShow',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '回单要求',
          field: 'rnRequireName',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '回单份数',
          field: 'rnRequireCount',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '回单签收图片',
          field: 'hdimgs',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '回单状态',
          field: 'returnStatusShow',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '运单状态',
          field: 'waybillStatusShow',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '已返开单网点',
          field: 'isRnOpenDeptShow',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '返回开单网点时间',
          field: 'rnOpenDeptTime',
          width: '160',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '返回客户时间',
          field: 'rnCustomerTime',
          width: '160',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '回单返回客户备注',
          field: 'rnCustomerRemarks',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '录单员',
          field: 'businessName',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '收货人',
          field: 'receiveContacts',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '收货人电话',
          field: 'receivePhone',
          width: '140',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '发货人',
          field: 'takeContacts',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '发货人电话',
          field: 'takePhone',
          width: '140',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '收回人',
          field: 'returnUserName',
          width: '110',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '收回时间',
          field: 'returnTime',
          width: '160',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据
      tableData5: [], //  表格数据
      myTableHeard5: [
        {
          name: '操作',
          field: 'allocationTypeShow',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '发出/接收部门',
          field: 'operationDeptName',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '发出/接收人',
          field: 'operationObjectName',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '计划接收部门',
          field: 'endDeptName',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '计划接收人',
          field: 'endObjectName',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '备注',
          field: 'remarks',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '操作人',
          field: 'updateUserName',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '操作时间',
          field: 'updateTime',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      allCheck: false, //  全选
      sortName: '回单管理模板', //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: '', //  导出需要
      pageGroupName: 'ReceiptManage', //  页面标识

      // 新建客服跟踪
      showDia1: false,
      documentNumbers: '',
      documentStatus: '', //包裹单据

      fileNameLists: [], //上传组件的
      fileNameLists6: [], //上传组件的
      StartfileNameLists6: [], //打开弹窗记录原有的图片
      startFids: [], //打开弹窗记录原有的图片
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: '',
      diaWidth: '40%',
      dialogForm: {
        // 弹窗表单数据
        fileIds: [],
        returnDeptId: '',
        returnUserId: '',
        rnorderIds: [],
      },
      rulesForm: {
        returnDeptId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
        returnUserId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog2: false,
      dialogTitle2: '',
      diaWidth2: '40%',
      dialogForm2: {
        // 弹窗表单数据
        rnCustomerRemarks: '',
        rnorderIds: [],
      },
      rulesForm2: {
        rnCustomerRemarks: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog3: false,
      dialogTitle3: '调拨发出',
      diaWidth3: '40%',
      dialogForm3: {
        endDeptId: '',
        endObjectId: '',
        operationDeptId: '',
        operationObjectId: '',
        remarks: '',
        rnorderId: '',
      },
      rulesForm3: {
        operationDeptId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
        operationObjectId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog4: false,
      dialogTitle4: '调拨接收',
      diaWidth4: '40%',
      dialogForm4: {
        operationDeptId: '',
        operationObjectId: '',
        remarks: '',
        rnorderId: '',
      },
      rulesForm4: {
        operationDeptId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
        operationObjectId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog5: false,
      dialogTitle5: '调拨记录',
      diaWidth5: '80%',

      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog6: false,
      dialogTitle6: '上传回单图',
      diaWidth6: '80%',
      rnorderId6: '',
      // ==== 弹窗组件属性 end ====

      depList: [],
      retraction_status_list: [],
      return_status_list: [],
      rn_customer_status_list: [],
      AccountList: [],
      employeeList: [],
      waybillStatusList: [],
      CustomerLists: [],
    }
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1
      }
      this.tabelHeadeTitle = arr
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      )
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum) //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate() //今天的时间;

    this.getData()
    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName)
    this.getStatusValListS('bill_tms_rnorder_v3.retraction_status')
    this.getStatusValListS('bill_tms_rnorder_v3.rn_customer_status')
    this.getStatusValListS('bill_tms_rnorder_v3.return_status')
    this.getWaybillStatus()
  },
  activated() {},
  mounted() {},
  watch: {},
  methods: {
    // 获取客户列表
    getCustomerList(number) {
      this.$API
        .wtl_getObjectUserDownList({
          key: 'customer',
          name: number,
          number: '',
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || []
        })
    },
    // 选择客户触发
    changeCustomerNumber(e) {
      if (!e) {
        this.getCustomerList()
      }
      this.queryBtn_ok()
    },
    // 获取运单状态
    getWaybillStatus() {
      this.$TOOLS
        .getStatusValList('bill_tms_waybill_split_v3.waybill_status')
        .then((res) => {
          this.waybillStatusList = res || []
        })
    },

    // 查看图片
    lookImgs(row) {
      let id = row.rnorderId || ''
      this.$API.wtl_getRnorderRnFileList({ rnorderId: id }).then((res) => {
        let filse = res.data.result || []
        if (filse && filse.length > 0) {
          let arrs = []
          arrs = filse.map((item) => {
            return item.fileUrl
          })
          // arrs.push(filse[0].fileUrl);
          console.log('arrs', arrs)
          this.srcList = arrs
          this.bigImgsShow = true
        } else {
          this.$message.warning('打开失败,没有检测到图片地址')
        }
      })
    },
    // 获取组织架构列表
    getDeptList() {
      this.$API
        .wtl_getDeptList({
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.depList = res.data.result.data || []
        })
    },
    //  getStatusValListS('bill_tms_rnorder_v3.retraction_status')
    getStatusValListS(type) {
      this.$TOOLS.getStatusValList(type).then((res) => {
        // 收回状态
        if (type == 'bill_tms_rnorder_v3.retraction_status') {
          this.retraction_status_list = res || []
        }
        // 回单状态
        if (type == 'bill_tms_rnorder_v3.return_status') {
          this.return_status_list = res || []
        }
        // 返客户状态
        if (type == 'bill_tms_rnorder_v3.rn_customer_status') {
          this.rn_customer_status_list = res || []
        }
      })
    },
    // 上传回单图片
    upLoadImgsBtns(row) {
      this.isShowDialog6 = true
      this.rnorderId6 = row.rnorderId

      this.$API
        .wtl_getRnorderFileList({
          rnorderId: row.rnorderId,
        })
        .then((res) => {
          let filesArrs = res.data.result || []
          let arrs = []
          let sFileIds = [] //记录原来的图片id
          filesArrs.forEach((item) => {
            let objs = {
              name: item.fileId,
              url: item.fileUrl,
              operationType: 'UNCHANGED',
            }
            arrs.push(objs)
            sFileIds.push(item.fileId)
          })
          this.fileNameLists6 = arrs
          this.StartfileNameLists6 = JSON.parse(JSON.stringify(arrs)) || []
          this.startFids = sFileIds
        })
    },
    // 调拨记录
    diaoBoLog(row) {
      this.$API
        .wtl_getAallocationRecordList({ rnorderId: row.rnorderId })
        .then((res) => {
          this.tableData5 = res.data.result || []
          this.isShowDialog5 = true
        })
    },
    // 调拨发出
    WaybillEdit(row) {
      let that = this
      this.isShowDialog3 = true
      this.dialogForm3.rnorderId = row.rnorderId

      this.$COMAPI.getObjectUserDownList('employee').then((res) => {
        this.employeeList = res || []
      }) //获取员工列表

      this.getDeptList()
    },
    // 调拨接收
    allocationReceive(row) {
      let that = this
      this.isShowDialog4 = true
      // 调拨接收
      this.dialogForm4.rnorderId = row.rnorderId

      this.$COMAPI.getObjectUserDownList('employee').then((res) => {
        this.employeeList = res || []
      }) //获取员工列表

      this.getDeptList()
    },

    // 删除
    delBtns(val) {
      // 右边单选
      if (val) {
        console.log('val')
        console.log(val)
        return false
      }
      // 上面多选
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      } else {
        this.$confirm('确定要删除所选数据吗?', '提示:')
          .then((res) => {
            console.log('删除了')
          })
          .catch((err) => {})
      }
    },

    // 取消回收确认
    cancelReturnSure() {
      let ids = []
      if (this.selectTableData.length < 1) {
        this.$message.error('还没选择需要操作的回单')
        return false
      }
      ids = this.selectTableData.map((item) => {
        return item.rnorderId
      })
      this.$confirm('是否把所选回单进行取消收回操作?,请谨慎操作', '提示:')
        .then(() => {
          this.$API.wtl_cancelReturnSure({ rnorderIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch(() => {})
    },

    // 收回确认
    SHConfirm() {
      if (this.selectTableData.length < 1) {
        this.$message.error('还没选择需要操作的回单')
        return false
      }
      this.isShowDialog = true
      this.dialogTitle = '收回确认'
      let ids = this.selectTableData.map((item) => {
        return item.rnorderId
      })
      this.dialogForm.rnorderIds = ids || []

      this.getDeptList()
      this.getAccountList()

      // 获取登录账号的信息(现在缺少账号id)
      // let userdata = this.$TOOLS.getUserInfo() || "";
    },
    // 返回客户
    returnCustomer() {
      if (this.selectTableData.length < 1) {
        this.$message.error('还没选择需要操作的回单')
        return false
      }
      this.isShowDialog2 = true
      this.dialogTitle2 = '返回客户'
      let ids = this.selectTableData.map((item) => {
        return item.rnorderId
      })
      this.dialogForm2.rnorderIds = ids || []
    },
    // 获取账号列表
    getAccountList(name) {
      this.$API
        .wtl_getAccountList({
          pageStart: 1,
          pageTotal: 200,
          name: name,
        })
        .then((res) => {
          this.AccountList = res.data.result.data || []
        })
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array
    },
    // 选择图片
    changeFileList6(array) {
      this.fileNameLists6 = array
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false
      this.dialogForm = {
        fileIds: [],
        returnDeptId: '',
        returnUserId: '',
        rnorderIds: [],
      }
      this.fileNameLists = []
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(this.dialogForm))
          let fids = []
          this.fileNameLists.forEach((item) => {
            fids.push(item.name)
          })
          param.fileIds = fids
          this.$API.wtl_returnSure(param).then((res) => {
            this.$message.success(res.data.message || '操作成功')

            this.isShowDialog = false
            this.$TOOLS.resetForm(this, formName)
            this.getData()
          })
        }
      })
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * ====== 弹窗组件方法 ======
     */
    // 返回客户
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false
      this.dialogForm2 = {
        rnCustomerRemarks: '',
        rnorderIds: [],
      }
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(this.dialogForm2))

          this.$API.wtl_returnCustomer(param).then((res) => {
            this.$message.success(res.data.message || '操作成功')

            this.isShowDialog2 = false
            this.$TOOLS.resetForm(this, formName)
            this.getData()
          })
        }
      })
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia3() {
      this.isShowDialog3 = false
      this.dialogForm3 = {
        endDeptId: '',
        endObjectId: '',
        operationDeptId: '',
        operationObjectId: '',
        remarks: '',
        rnorderId: '',
      }
    },
    //  弹窗确认保存事件
    diaConfirmBtn3(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(this.dialogForm3))

          this.$API.wtl_allocationSend(param).then((res) => {
            this.$message.success(res.data.message || '操作成功')

            this.isShowDialog3 = false
            this.$TOOLS.resetForm(this, formName)
            this.getData()
          })
        }
      })
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia4() {
      this.isShowDialog4 = false
      this.dialogForm4 = {
        operationDeptId: '',
        operationObjectId: '',
        remarks: '',
        rnorderId: '',
      }
    },
    //  弹窗确认保存事件
    diaConfirmBtn4(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(this.dialogForm4))

          this.$API.wtl_allocationReceive(param).then((res) => {
            this.$message.success(res.data.message || '操作成功')

            this.isShowDialog4 = false
            this.$TOOLS.resetForm(this, formName)
            this.getData()
          })
        }
      })
    },

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia6() {
      this.isShowDialog6 = false
      this.fileNameLists6 = []
      this.StartfileNameLists6 = []
      this.startFids = []
      this.rnorderId6 = ''
    },
    //  弹窗确认保存事件
    diaConfirmBtn6(formName) {
      // operationType   ADD 为 新增; UPDATE 为 修改; UNCHANGED 为 不变(不做任何操作变化); DEL 为 删除;
      // [1,2,3] [2,3,4]
      let arr1 = []
      let fileNameLists6 = JSON.parse(JSON.stringify(this.fileNameLists6))
      let StartfileNameLists6 = JSON.parse(
        JSON.stringify(this.StartfileNameLists6)
      )
      console.log('fileNameLists6', fileNameLists6)
      console.log('StartfileNameLists6', StartfileNameLists6)
      if (StartfileNameLists6.length > 0) {
        // 把原来的数组跟修改后的对比,找出删除的
        // 把修改后的数组跟原来的对比,找出新增的
        let ids2 = fileNameLists6.map((item) => {
          return item.name
        })
        for (var a = 0; a < StartfileNameLists6.length; a++) {
          if (ids2.indexOf(StartfileNameLists6[a].name) == -1) {
            StartfileNameLists6[a].operationType = 'DEL'
          }
        }
        let addArrs = []
        for (var a = 0; a < fileNameLists6.length; a++) {
          if (this.startFids.indexOf(fileNameLists6[a].name) == -1) {
            let obj = {
              fileId: fileNameLists6[a].name,
              operationType: 'ADD',
            }
            addArrs.push(obj)
          }
        }

        StartfileNameLists6.forEach((item) => {
          let obj = {
            fileId: item.name,
            operationType: item.operationType,
          }
          arr1.push(obj)
        })
        arr1 = arr1.concat(addArrs)
      } else {
        this.fileNameLists6.forEach((item) => {
          let obj = {
            fileId: item.name,
            operationType: 'ADD',
          }
          arr1.push(obj)
        })
      }

      let param = {
        fileIds: arr1,
        rnorderId: this.rnorderId6,
      }

      this.$API.wtl_uploadRnorderFile(param).then((res) => {
        this.$message.success(res.data.message || '操作成功')
        this.isShowDialog6 = false
        this.$TOOLS.resetForm(this, formName)
        this.getData()
      })
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    goYdDetails(a) {
      // this.$message.success("你点我干嘛");
      this.$router.push({
        path: '/WaybillManage/WaybillDetails',
        query: {
          yd: '123',
        },
      })
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || ''
      this.endTime_a = e || ''
      this.getData()
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || '0'
      this.startTime_a = s || ''
      this.endTime_a = e || ''
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false
      this.getData()
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false
      this.documentNumbers = '' //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row)
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row)
    },

    getData() {
      let param = JSON.parse(JSON.stringify(this.queryData))
      param.pageStart = this.pageStart
      param.pageTotal = this.pageTotal

      let startTime = this.startTime_a ? this.startTime_a + ' 00:00:00' : ''
      let endTime = this.endTime_a ? this.endTime_a + ' 23:59:59' : ''

      if (this.timeType == '0') {
        //创建时间
        param.startCreateTime = startTime
        param.endCreateTime = endTime
        param.startReturnTime = ''
        param.endReturnTime = ''
      } else {
        // 回收时间
        param.startReturnTime = startTime
        param.endReturnTime = endTime
        param.startCreateTime = ''
        param.endCreateTime = ''
      }

      this.$API.wtl_getRnorderList(param).then((res) => {
        if (res.data.status === 'success') {
          this.className = res.data.result.className || ''
          this.tableData = res.data.result.data || []
          this.pageCount = res.data.result.pageCount || 0

          this.$nextTick(() => {
            this.fetTableHeight()
          })
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`)
        }
      })
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1
      this.getData()
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {}
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore
      if (this.isHaseMore) {
        this.MoreConditions = '收起条件'
      } else {
        this.MoreConditions = '更多条件'
      }

      this.$nextTick(() => {
        this.fetTableHeight()
      })
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val
      this.getData()
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val
      this.getData()
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: '/BusinessManagement/addPacks',
      })
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: '/BusinessManagement/addPacks',
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        })
      } else {
        this.$message.error('请选一个需要修改的包裹')
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: '/BusinessManagement/packsDetails',
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        })
      } else {
        this.$router.push({
          path: '/BusinessManagement/packsDetails',
        })
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            'chu_ku_zai_tu:package_status' ||
          this.selectTableData[0].packageStatus ==
            'ke_hu_qian_shou:package_status' ||
          this.selectTableData[0].packageStatus ==
            'chu_ku_zhong:package_status' ||
          this.selectTableData[0].packageStatus ==
            'da_bao_wan_cheng:package_status'
        ) {
          this.$router.push({
            path: '/BusinessManagement/dabaoDetails',
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          })
        } else {
          this.$message.error('包裹未打包完成')
        }
      } else {
        this.$message.error('请选择一个包裹')
      }
    },

    // 表格合计
    getSummaries(param) {
      let that = this
      const { columns, data } = param

      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr)
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(this.$TOOLS.add(prev, curr), 2)
                } else {
                  return prev
                }
              }, 0)
              sums[index] += ''
            } else {
              sums[index] = '---'
            }
          }
        }
      })
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
      return sums
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight //页面高度
      let queryHeigth = 40 + 10 //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10 //查询框
      }
      let pagsHeigth = 40 + 20 //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60 //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || '' //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight
        this.$refs.mytable.doLayout()
      })
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === 'bgsz') {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this)
      }
      if (a === 'dyyd') {
        // 打印运单
      }
      if (a === 'dybq') {
        // 打印标签
      }
      if (a === 'dr') {
        // 导入
      }
      if (a === 'jtdc') {
        // 新版导出
        this.isShowDialog_dc = true
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: '表名(暂无效)', //表名
      })
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      console.log(type)
      console.log(val)
      // a==详情
      if (type === 'a') {
        this.$router.push('/WaybillManage/WaybillDetails')
      }
      // d==删除
      if (type === 'd') {
        this.delBtns(val)
      }
    },

    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e
      this.myTableHeard = this.tabelHeadeTitle
      let sortObject = this.myTableHeard
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      }
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || '操作成功')
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName)
      })
      this.show_sortTableHeard = false //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
      this.show_sortTableHeard = false
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this
      that.tabelHeadeTitle[idx].isShow = e
      let selectLength = 0
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++
        }
      }
      that.selectLength = selectLength
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true
      } else {
        that.allCheck = false
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this
      this.allCheck = e
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e
      }
      let selectLength = 0
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++
        }
      }
      that.selectLength = selectLength
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
}
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
